<template>
  <v-app>
    <AppHeader></AppHeader>

    <v-main>
      <router-view />
    </v-main>

    <AppError></AppError>

    <AppFooter></AppFooter>
  </v-app>
</template>

<script>
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import AppError from "@/components/AppError.vue";

export default {
  name: "App",
  components: {
    AppHeader,
    AppFooter,
    AppError,
  },
  data: () => ({
    //
  }),
  computed: {
    loading() {
      return this.$store.state.loader.loading;
    },
  },
};
</script>
<style></style>
